<form [formGroup]="form">
  <mat-toolbar color="accent">
    <mat-toolbar-row>
      <button mat-button (click)="onClose()">
        <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
        Close
      </button>
      <span class="toolbar-spacer"></span>
      <button mat-button [disabled]="!form.dirty" (click)="onReset()">
        <mat-icon aria-hidden="false" aria-label="Cancel">cancel</mat-icon>
        Cancel
      </button>
      <button mat-button [disabled]="!form.valid || !form.dirty" (click)="onSave()">
        <mat-icon aria-hidden="false" aria-label="Save">save</mat-icon>
        Save
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="sections">
    <section>
      <mat-form-field appearance="outline">
        <mat-label>Version</mat-label>
        <input matInput formControlName="version" />
        <mat-error *ngIf="form.get('version')?.hasError('required')">Version is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input matInput formControlName="date" placeholder="YYYY-MM-DD" />
        <mat-error *ngIf="form.get('date')?.hasError('required')">Date is required</mat-error>
        <mat-error *ngIf="form.get('date')?.hasError('pattern')">Date must be in YYYY-MM-DD format</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select formControlName="type">
          @for (t of types; track t.value) {
            <mat-option [value]="t.value">{{ t.label }}</mat-option>
          }
        </mat-select>
        <mat-error *ngIf="form.get('type')?.hasError('required')">Type is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" />
        <mat-error *ngIf="form.get('title')?.hasError('required')">Title is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="4"></textarea>
        <mat-error *ngIf="form.get('description')?.hasError('required')">Description is required</mat-error>
      </mat-form-field>
    </section>
  </div>
</form>
